import { Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button, EmptyState, PageHeader } from "@lumika/ui";

export function DealershipsLandingPage() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        eyebrow="Tenant operations"
        title="Dealerships"
        description="Onboard, configure, and monitor every dealership running on lumika BDC."
      />
      <EmptyState
        icon={<Building2 className="h-5 w-5" />}
        title="Pick a dealership from the sidebar"
        description="Or create a new one to kick off an onboarding."
        action={
          <Button onClick={() => navigate("/dealerships/new")}>
            Create a dealership
          </Button>
        }
      />
    </div>
  );
}
